module.exports = __webpack_public_path__ + "static/image/company/m/image_report@3x.ver2_0_2.jpg?b8fc14a0";